// This file will be replaced when building for production with `environment.prod.ts`

import { Config } from '@danone-global/internal/react/core'

import { baseEnvironment } from './environment.base'

export const environment: Config = {
  ...baseEnvironment,

  isProduction: false,

  isDevelopment: true,

  ctProjectKey: 'dach-test-danone',

  ctClientId: 'neL8e3AMYoEgDT3UXQ-LjTL-',

  ctClientSecret: 'ddIenAqxXYemEkwLezUizZcA2k0_0Qyv',

  defaultChannelId: '43faf505-19eb-4514-9e4c-ec2f95d10afe',

  sentryDSN:
    'https://26e95ebef18de217c29264c5f256280b@o4506427613577216.ingest.sentry.io/4506433323008000',

  loqate: {
    apiKey: 'NH44-PZ36-ER76-NP17',
    countries: ['DE', 'AT'],
  },

  adyen: {
    clientKey: 'test_PFHTONV55BAELL4JAK35JFW6ZULK3IPU',
    environment: 'test',

    googlePay: {
      environment: 'TEST',
      gatewayMerchantId: 'DanoneNutricia',
      merchantName: 'Nutricia GmbH',
    },
  },
}
